import type { ItemCardDto } from 'tradera/state/services/types/webapi-discover-generated';

export type ItemDtoPlaceHolder = Pick<
    ItemCardDto,
    'itemId' | 'shortDescription' | 'itemUrl'
>;

export const generateItemCardPlaceholders = (
    itemCount: number,
    text?: string
): Array<ItemDtoPlaceHolder> =>
    [...new Array(Math.floor(itemCount))].map((_, index) => ({
        itemId: index,
        shortDescription: index === 0 && text ? text : '',
        itemUrl: ''
    }));
